'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiper = require('./swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _swiper2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/swiper/index.js
// module id = 792
// module chunks = 0